module.exports = __webpack_public_path__ + "assets/img/mpic3.b4500a0e.png";